const m = (ca, es, en, fr) => ({ ca, es, en, fr });

// Enrichment per service: problems solved, benefits and FAQs (multilingual)
export const SERVICE_EXTRA = {
  software: {
    problems: [
      m("Processos manuals que consumeixen hores cada dia.", "Procesos manuales que consumen horas cada día.", "Manual processes eating up hours every day.", "Des processus manuels qui coûtent des heures chaque jour."),
      m("Eines desconnectades que dupliquen la feina.", "Herramientas desconectadas que duplican el trabajo.", "Disconnected tools that duplicate work.", "Des outils déconnectés qui dupliquent le travail."),
      m("Falta de visibilitat sobre les dades del negoci.", "Falta de visibilidad sobre los datos del negocio.", "Lack of visibility over business data.", "Manque de visibilité sur les données de l'entreprise."),
    ],
    benefits: [
      m("Software fet a la teva mida, no al revés.", "Software hecho a tu medida, no al revés.", "Software built around you, not the other way around.", "Un logiciel conçu sur mesure, pas l'inverse."),
      m("Menys errors i més productivitat.", "Menos errores y más productividad.", "Fewer errors and more productivity.", "Moins d'erreurs et plus de productivité."),
      m("Escalable a mesura que creixes.", "Escalable a medida que creces.", "Scalable as you grow.", "Évolutif à mesure que vous grandissez."),
    ],
  },
  saas: {
    problems: [
      m("Costos alts de llicències i manteniment.", "Costes altos de licencias y mantenimiento.", "High licensing and maintenance costs.", "Coûts élevés de licences et de maintenance."),
      m("Dificultat per gestionar múltiples empreses o equips.", "Dificultad para gestionar múltiples empresas o equipos.", "Hard to manage multiple companies or teams.", "Difficulté à gérer plusieurs entreprises ou équipes."),
    ],
    benefits: [
      m("Ingressos recurrents i predictibles.", "Ingresos recurrentes y predecibles.", "Predictable recurring revenue.", "Revenus récurrents et prévisibles."),
      m("Onboarding de clients en minuts.", "Onboarding de clientes en minutos.", "Customer onboarding in minutes.", "Intégration des clients en minutes."),
      m("Disponibilitat i seguretat garantides.", "Disponibilidad y seguridad garantizadas.", "Guaranteed uptime and security.", "Disponibilité et sécurité garanties."),
    ],
  },
  ai: {
    problems: [
      m("Volum de documents impossible de processar manualment.", "Volumen de documentos imposible de procesar manualmente.", "Document volume impossible to process manually.", "Volume de documents impossible à traiter manuellement."),
      m("Atenció al client saturada.", "Atención al cliente saturada.", "Overwhelmed customer support.", "Support client saturé."),
    ],
    benefits: [
      m("Automatització intel·ligent 24/7.", "Automatización inteligente 24/7.", "Intelligent automation 24/7.", "Automatisation intelligente 24/7."),
      m("Decisions basades en dades i prediccions.", "Decisiones basadas en datos y predicciones.", "Data- and prediction-driven decisions.", "Décisions basées sur les données et prédictions."),
      m("Millor experiència amb assistents conversacionals.", "Mejor experiencia con asistentes conversacionales.", "Better experience with conversational assistants.", "Meilleure expérience avec des assistants conversationnels."),
    ],
  },
  "smart-cities": {
    problems: [
      m("Incidències que es perden entre departaments.", "Incidencias que se pierden entre departamentos.", "Incidents lost between departments.", "Des incidents perdus entre les services."),
      m("Comunicació lenta amb la ciutadania.", "Comunicación lenta con la ciudadanía.", "Slow communication with citizens.", "Communication lente avec les citoyens."),
    ],
    benefits: [
      m("Resposta més ràpida a les incidències.", "Respuesta más rápida a las incidencias.", "Faster incident response.", "Réponse plus rapide aux incidents."),
      m("Ciutadania informada i participativa.", "Ciudadanía informada y participativa.", "Informed and engaged citizens.", "Des citoyens informés et engagés."),
      m("Dades per prioritzar inversions.", "Datos para priorizar inversiones.", "Data to prioritize investments.", "Des données pour prioriser les investissements."),
    ],
  },
  commerce: {
    problems: [
      m("Dificultat per fidelitzar clients.", "Dificultad para fidelizar clientes.", "Hard to retain customers.", "Difficulté à fidéliser les clients."),
      m("Poca informació sobre el comportament de compra.", "Poca información sobre el comportamiento de compra.", "Little insight into buying behaviour.", "Peu d'informations sur le comportement d'achat."),
    ],
    benefits: [
      m("Més recurrència i tiquet mitjà.", "Más recurrencia y ticket medio.", "More repeat business and higher basket size.", "Plus de récurrence et de panier moyen."),
      m("Campanyes segmentades i mesurables.", "Campañas segmentadas y medibles.", "Segmented, measurable campaigns.", "Campagnes segmentées et mesurables."),
    ],
  },
  restauration: {
    problems: [
      m("Comandes i reserves gestionades a mà.", "Pedidos y reservas gestionados a mano.", "Orders and bookings managed by hand.", "Commandes et réservations gérées à la main."),
      m("Falta de control sobre costos per plat.", "Falta de control sobre costes por plato.", "No control over per-dish costs.", "Aucun contrôle des coûts par plat."),
    ],
    benefits: [
      m("Més rotació de taules i vendes.", "Más rotación de mesas y ventas.", "Higher table turnover and sales.", "Meilleure rotation des tables et ventes."),
      m("Control total d'escandalls i APPCC.", "Control total de escandallos y APPCC.", "Full recipe-cost and HACCP control.", "Contrôle total des coûts et HACCP."),
    ],
  },
  associations: {
    problems: [
      m("Gestió de socis i quotes lenta i propensa a errors.", "Gestión de socios y cuotas lenta y propensa a errores.", "Slow, error-prone member and fee management.", "Gestion des membres et cotisations lente et sujette aux erreurs."),
    ],
    benefits: [
      m("Cobrament de quotes automatitzat.", "Cobro de cuotas automatizado.", "Automated fee collection.", "Prélèvement automatisé des cotisations."),
      m("Comunicació directa amb els socis.", "Comunicación directa con los socios.", "Direct communication with members.", "Communication directe avec les membres."),
    ],
  },
  "public-administration": {
    problems: [
      m("Tràmits presencials i en paper.", "Trámites presenciales y en papel.", "In-person, paper-based procedures.", "Démarches en présentiel et sur papier."),
    ],
    benefits: [
      m("Tràmits digitals 24/7 per a la ciutadania.", "Trámites digitales 24/7 para la ciudadanía.", "24/7 digital procedures for citizens.", "Démarches numériques 24/7 pour les citoyens."),
      m("Conformitat amb accessibilitat i normativa.", "Conformidad con accesibilidad y normativa.", "Accessibility and regulatory compliance.", "Conformité en accessibilité et réglementation."),
    ],
  },
  digitalization: {
    problems: [
      m("Massa paper i processos desconnectats.", "Demasiado papel y procesos desconectados.", "Too much paper and disconnected processes.", "Trop de papier et de processus déconnectés."),
    ],
    benefits: [
      m("Visibilitat total del negoci en temps real.", "Visibilidad total del negocio en tiempo real.", "Full real-time business visibility.", "Visibilité totale de l'entreprise en temps réel."),
      m("Menys costos operatius.", "Menos costes operativos.", "Lower operating costs.", "Moins de coûts opérationnels."),
    ],
  },
  automation: {
    problems: [
      m("Tasques repetitives que consumeixen el teu equip.", "Tareas repetitivas que consumen a tu equipo.", "Repetitive tasks draining your team.", "Des tâches répétitives qui épuisent votre équipe."),
    ],
    benefits: [
      m("Hores estalviades cada setmana.", "Horas ahorradas cada semana.", "Hours saved every week.", "Des heures gagnées chaque semaine."),
      m("Processos sense errors humans.", "Procesos sin errores humanos.", "Processes free of human error.", "Des processus sans erreur humaine."),
    ],
  },
  integrations: {
    problems: [
      m("Dades disperses en eines que no es parlen.", "Datos dispersos en herramientas que no se hablan.", "Data scattered across tools that don't talk.", "Des données éparpillées dans des outils qui ne communiquent pas."),
    ],
    benefits: [
      m("Una única font de veritat.", "Una única fuente de verdad.", "A single source of truth.", "Une source unique de vérité."),
      m("Estalvi de temps en tasques duplicades.", "Ahorro de tiempo en tareas duplicadas.", "Time saved on duplicate work.", "Du temps gagné sur les tâches en double."),
    ],
  },
};

export const SERVICE_FAQS = [
  {
    q: m("Quant triga a desenvolupar-se un projecte?", "¿Cuánto tarda en desarrollarse un proyecto?", "How long does a project take?", "Combien de temps dure un projet ?"),
    a: m("Depèn de l'abast, però treballem amb lliuraments àgils perquè vegis resultats des de les primeres setmanes.", "Depende del alcance, pero trabajamos con entregas ágiles para que veas resultados desde las primeras semanas.", "It depends on scope, but we work with agile deliveries so you see results within the first weeks.", "Cela dépend du périmètre, mais nous livrons en agile pour des résultats dès les premières semaines."),
  },
  {
    q: m("Oferiu manteniment després del llançament?", "¿Ofrecéis mantenimiento tras el lanzamiento?", "Do you offer maintenance after launch?", "Proposez-vous une maintenance après le lancement ?"),
    a: m("Sí. Acompanyem el client amb suport i evolució contínua del producte.", "Sí. Acompañamos al cliente con soporte y evolución continua del producto.", "Yes. We support clients with maintenance and continuous product evolution.", "Oui. Nous accompagnons le client avec support et évolution continue."),
  },
  {
    q: m("Puc integrar-ho amb els meus sistemes actuals?", "¿Puedo integrarlo con mis sistemas actuales?", "Can it integrate with my current systems?", "Puis-je l'intégrer à mes systèmes actuels ?"),
    a: m("Absolutament. Connectem amb ERP, CRM, passarel·les de pagament i qualsevol API.", "Absolutamente. Conectamos con ERP, CRM, pasarelas de pago y cualquier API.", "Absolutely. We connect with ERP, CRM, payment gateways and any API.", "Absolument. Nous connectons ERP, CRM, passerelles de paiement et toute API."),
  },
];
